import * as React from 'react';
import { createApiClient } from '../../../services/ApiClient';
import { Modal, Button} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


interface StatusRequest {
    createTime: string;
    newStatusId: number;
    oldStatusId: number;
    user: string;
}

interface State {
    form: string;
    request: number;
    history: Array<StatusRequest>;
    show: boolean;
}

const statusFormate = (cell) => {
    switch (cell) {
        case 'Черновик': return (<span className="label">Черновик</span>);
        case 'На рассмотрении Фонда': return (<span className="label">На рассмотрении Фонда</span>);
        case 'Одобрена': return (<span className="label">Одобрена</span>);
        case 'Отправлено': return (<span className="label">Отправлено</span>);
        case 'Отклонена': return (<span className="label">Отклонена</span>);
        case 'Ожидание PDF': return (<span className="label">Ожидание PDF</span>);
        case 'Запрошены документы': return (<span className="label" style={{whiteSpace:"pre-line"}}>Запрошены документы</span>);
        case 'На рассмотрении': return (<span className="label" style={{whiteSpace:"pre-line"}}>На рассмотрении</span>); 
        case 'Документы отправлены': return (<span className="label" style={{whiteSpace:"pre-line"}}>Документы отправлены</span>);
        case 'Отозвана': return (<span className="label">Отозвана</span>);
        case 'Дополнительный запрос': return (<span className="label" title="Дополнительный запрос">Дополнительный запрос</span>);
        default: return (<span className="label" style={{whiteSpace:"pre-line"}}>{cell}</span>);
    }
}

const userFormate = (cell) => {
    switch (cell) {
        case 1:
            return 'Фонд «Сколково»'
        case 2:
            return 'Вы'
        case null:
        default:
                return ''

    }
}

const dateFormatter = (cell, row) => {
    const date = new Date(cell);

    if (date instanceof Date) {
        // const date = new Date(Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), sourceDate.getHours(), sourceDate.getMinutes(), sourceDate.getSeconds()));
        return `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()} ${('0' + (date.getHours())).slice(-2)}:${('0' + (date.getMinutes())).slice(-2)}`;
    }

    return null
}

class HistoryStatusModal extends React.Component<{}, State>{
    constructor() {
        super();
        this.state = {
            form: "",
            request: 0,
            history: [],
            show: false
        }
        this.handleClose = this.handleClose.bind(this);
        this.onEnter = this.onEnter.bind(this);
    }

    handleClose() {
        this.setState({ show: false })
    }

    public show(request: number) {
        this.setState({
            request,
            show: true,
            history: []
        })
    }

    onEnter(){
        const client = createApiClient();
        const { request } = this.state;

        client.getHistory(request,{
            success: (data) =>{
                this.setState({ history: data });
            }
        });
    }

    render() {
        const config ={
            bordered: false,
            height: '310px',
            options: {
                noDataText: 'У вас пока нет историй изменений статусов в заявке ',
            }
        }

        return (
            <Modal onEnter={this.onEnter} show={this.state.show} onHide={this.handleClose} style={{ overlay: { backgroundColor: 'rgba(0,0,0,.25)' }}}>
                <Modal.Header closeButton>
                    <Modal.Title>История</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <BootstrapTable {...config} data={this.state.history} >
                        <TableHeaderColumn dataField='index' isKey={true} hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='created_at' dataFormat={dateFormatter}>Дата изменения</TableHeaderColumn>
                        <TableHeaderColumn dataField='status'  dataFormat={statusFormate}>Новый статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='source'  dataFormat={userFormate}>Пользователь</TableHeaderColumn>
                        <TableHeaderColumn dataField='comment'>Комментарий</TableHeaderColumn>
                   </BootstrapTable>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default HistoryStatusModal;
